import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PagesInstructions } from '@web-kc/pages/instructions';

export default PagesInstructions;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale = 'ru',
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? defaultLocale, [
        'common',
        'documents',
      ])),
    },
  };
};
